<template>
  <v-form ref="form" v-model="valid">
    <md-table>
      <md-table-row class="input-row">
        <md-table-cell>
          Edit parameters
        </md-table-cell>
        <md-table-cell md-label="Basal dose">
          <v-text-field
            label="Basal dose"
            type="number"
            class="mt-4"
            :rules="[$rules.required, $rules.decimal]"
            v-model="form.basaDose"
            outlined
            dense
          ></v-text-field>
        </md-table-cell>

        <md-table-cell md-label="Breakfast">
          <v-text-field
            label="Breakfast"
            type="number"
            class="mt-4"
            :rules="[$rules.required, $rules.decimal]"
            v-model="form.breakfast"
            outlined
            dense
          ></v-text-field>
        </md-table-cell>
        <md-table-cell md-label="Lunch">
          <v-text-field
            label="Lunch"
            type="number"
            class="mt-4"
            :rules="[$rules.required, $rules.decimal]"
            v-model="form.lunch"
            outlined
            dense
          ></v-text-field>
        </md-table-cell>
        <md-table-cell md-label="Dinner">
          <v-text-field
            label="Dinner"
            type="number"
            class="mt-4"
            :rules="[$rules.required, $rules.decimal]"
            v-model="form.supper"
            outlined
            dense
          ></v-text-field>
        </md-table-cell>
        <md-table-cell md-label="Bedtime">
          <v-text-field
            label="Bedtime"
            type="number"
            class="mt-4"
            :rules="[$rules.required, $rules.decimal]"
            v-model="form.bedtime"
            outlined
            dense
          ></v-text-field>
        </md-table-cell>

        <md-table-cell md-label="Admin">
          <md-dialog :md-active.sync="paramsNotesPromptActive">
            <md-dialog-title
              >Private notes (only visible to admins)</md-dialog-title
            >
            <md-dialog-content>
              <md-field>
                <label>Notes</label>
                <md-textarea v-model="form.privateNotes"></md-textarea>
              </md-field>
            </md-dialog-content>
            <md-dialog-actions>
              <md-button
                class="md-primary"
                @click="paramsNotesPromptActive = false"
                >Done</md-button
              >
            </md-dialog-actions>
          </md-dialog>

          <v-btn class="mr-4" @click="paramsNotesPromptActive = true">
            Notes
          </v-btn>

          <v-btn :disabled="!valid" color="primary" @click="validate">
            Save
          </v-btn>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </v-form>
</template>

<style scoped>
.md-card-content {
  padding-top: 0px;
}
.updated-by-chip {
  margin-left: 10px;
}
.acknowledged-chip {
  margin-left: 10px;
}
</style>

<script>
import { validationMixin } from "vuelidate";
import { required, decimal } from "vuelidate/lib/validators";

import { mapState } from "vuex";

export default {
  name: "parameters-form",
  mixins: [validationMixin],
  data: () => ({
    valid: true,
    sending: false,
    paramsNotesPromptActive: false,
    form: {
      basaDose: null,
      breakfast: null,
      lunch: null,
      supper: null,
      bedtime: null,
      privateNotes: null
    },
    params: null
  }),
  computed: {
    ...mapState(["currentStudy", "adminUser"]),
    isAM: function() {
      return this.currentStudy.params.isAM;
    },
    isAMPrefix: function() {
      return this.isAM ? "insuCarbRatio" : "insuDose";
    }
  },
  mounted() {
    let paramsCopy = JSON.parse(JSON.stringify(this.currentStudy.params));

    let form = {
      basaDose: paramsCopy.basaDose,
      breakfast: paramsCopy[this.isAMPrefix].breakfast,
      lunch: paramsCopy[this.isAMPrefix].lunch,
      supper: paramsCopy[this.isAMPrefix].supper,
      bedtime: paramsCopy[this.isAMPrefix].bedtime
    };

    delete paramsCopy.privateNotes;
    delete paramsCopy.insuDose;
    delete paramsCopy.insuCarbRatio;
    delete paramsCopy.updatedBy;
    delete paramsCopy.adminUserId;
    delete paramsCopy.timestamp;
    delete paramsCopy.id;

    this.params = paramsCopy;
    this.form = form;
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.saveParams();
      }
    },

    async saveParams() {
      let params = this.params;

      let {
        basaDose,
        breakfast,
        lunch,
        supper,
        bedtime,
        privateNotes
      } = this.form;
      params.basaDose = basaDose;
      params.privateNotes = privateNotes || null;
      params[this.isAMPrefix] = { breakfast, lunch, supper, bedtime };

      this.$store.dispatch("pushParams", params);
    }
  },
  validations: {
    form: {
      basaDose: {
        required,
        decimal
      },
      breakfast: {
        required,
        decimal
      },
      lunch: {
        required,
        decimal
      },
      supper: {
        required,
        decimal
      },
      bedtime: {
        required,
        decimal
      }
    }
  }
};
</script>
